import { z } from "zod"
import { Errors } from "../errors"
import { PaginationSchema } from "../shared/pagination_dtos"
import { QuerySchema } from "../shared/query_dtos"
import { Locale } from "./response_data"

const LOCALE_ENUM = z.enum(Locale, {
  error: Errors.LOCALE_REQUIRED,
})

export const InviteEmployeeSchema = z.strictObject({
  name: z.string({ error: Errors.EMPLOYEE_NAME_REQUIRED }),
  email: z.string().trim().toLowerCase().email(Errors.EMPLOYEE_EMAIL_INVALID),
  companyIds: z.array(z.string()).default([]),
})

export const UpdateEmployeeSchema = z.strictObject({
  currentPassword: z.string().optional(),
  password: z.string().optional(),
  confirmNewPassword: z.string().optional(),
  locale: LOCALE_ENUM.optional(),
})

export const UpdateEmployeeImageSchema = z
  .object({
    avatar: z
      .object({
        data: z.unknown().refine((value) => Buffer.isBuffer(value), { error: "Expected a Buffer" }),
        name: z.string(),
        mimetype: z.string(),
      })
      .nullable()
      .optional(),
  })
  .optional()

export const UpdateEmployeeLocaleSchema = z.object({
  locale: LOCALE_ENUM,
})

export const ListEmployeesSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape).shape,
})

export const GetEmployeeSchema = z.object({
  id: z.string({ error: Errors.ID_REQUIRED }),
})

export const GetEmployeeParamSchema = z.object({
  id: z.string({ error: Errors.ID_REQUIRED }),
})
